import React from "react";

import { getPremiumMap } from "lib/premium-helpers";

const { creditCardMap } = getPremiumMap();

interface CreditCard {
  brand?: string | null;
  last4?: string | null;
  expMonth?: number | null;
  expYear?: number | null;
  name?: string | null;
}

interface PaymentMethodProps {
  creditCard: CreditCard;
}

const PaymentMethod: React.FC<PaymentMethodProps> = ({ creditCard }) => {
  const cardIconId = creditCard.brand ? (creditCardMap as Record<string, number>)[creditCard.brand] || "1" : "1";

  return (
    <div className="cc">
      <div className="cc-details">
        <img
          className="cc-img"
          src={`https://static.bigbrain.gg/assets/ugg/icons/light-payment/${cardIconId}.png`}
          alt={creditCard.brand || "Card"}
        />
        <div className="cc-info">
          <div className="cc-name">{`${creditCard.brand || "Card"} ending with ${creditCard.last4}`}</div>
          <div className="cc-exp">{`Expires ${creditCard.expMonth}/${creditCard.expYear}`}</div>
        </div>
      </div>
      <div className="cc-owner">
        <div className="cc-owner_label">{"Name on Card"}</div>
        <span className="cc-owner_name">{creditCard.name}</span>
      </div>
    </div>
  );
};

export default PaymentMethod;
